import { render, staticRenderFns } from "./LegoModalDependents.vue?vue&type=template&id=5bc71cae&scoped=true"
import script from "./LegoModalDependents.vue?vue&type=script&lang=js"
export * from "./LegoModalDependents.vue?vue&type=script&lang=js"
import style0 from "./LegoModalDependents.vue?vue&type=style&index=0&id=5bc71cae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc71cae",
  null
  
)

export default component.exports